module.exports = __webpack_public_path__ + "img/177-5b3b93.png";